export { default as SystemSupplier } from './page';



// WEBPACK FOOTER //
// ./src/pages/systemSupplier/index.js